import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import LanguageRouter from './components/common/LanguageRouter';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogArticlePage from './pages/BlogArticlePage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import PetFormPage from './pages/PetFormPage';
import PetProfilePage from './pages/PetProfilePage';
import SharePage from './pages/SharePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import SettingsPage from './pages/SettingsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import NotFoundPage from './pages/NotFoundPage';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/common/ScrollToTop';
import SupabaseStatus from './components/Debug/SupabaseStatus';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <HashRouter>
        <AuthProvider>
          <LanguageProvider>
            <ThemeProvider>
              <ScrollToTop />
              <div className="flex flex-col min-h-screen bg-neutral-50">
                <Navbar />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Navigate to="/en" replace />} />
                    <Route path="/:lang" element={<LanguageRouter />}>
                      <Route index element={<HomePage />} />
                      <Route path="features" element={<FeaturesPage />} />
                      <Route path="about" element={<AboutPage />} />
                      <Route path="contact" element={<ContactPage />} />
                      <Route path="blog" element={<BlogPage />} />
                      <Route path="blog/:slug" element={<BlogArticlePage />} />
                      <Route path="auth" element={<AuthPage />} />
                      <Route path="reset-password" element={<ResetPasswordPage />} />
                      <Route path="privacy" element={<PrivacyPage />} />
                      <Route path="terms" element={<TermsPage />} />
                      <Route
                        path="dashboard"
                        element={
                          <ProtectedRoute>
                            <DashboardPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="settings"
                        element={
                          <ProtectedRoute>
                            <SettingsPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="pet/add"
                        element={
                          <ProtectedRoute>
                            <PetFormPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="pet/edit/:id"
                        element={
                          <ProtectedRoute>
                            <PetFormPage />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="pet/:id"
                        element={
                          <ProtectedRoute>
                            <PetProfilePage />
                          </ProtectedRoute>
                        }
                      />
                      <Route path="share/:shareToken" element={<SharePage />} />
                      <Route path="*" element={<NotFoundPage />} />
                    </Route>
                    <Route path="*" element={<NotFoundPage />} />
                  </Routes>
                </main>
                <Footer />
                <SupabaseStatus />
              </div>
            </ThemeProvider>
          </LanguageProvider>
        </AuthProvider>
      </HashRouter>
    </HelmetProvider>
  );
}

export default App;